import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createProject, incrementCount } from '../../store/actions/projectActions'
import { Redirect } from 'react-router-dom'
import CreateModal from './CreateModal';
// import firebase from "firebase";
// import jsPDF from 'jspdf';
import moment from 'moment';
import VerifyEmail from '../layout/VerifyEmail';
// import base64Img from 'base64-img';
import M from 'materialize-css';
M.AutoInit();

const esignStyle = {
	width: '250px',
	height: '150px'
}
class CreateTemplate extends Component {

	state = {
		title: '',
		content: '',
		email1: this.props.auth.email,
		email2: '',
		withCompany: false,
		companyTitle1: null,
		companyName1: null,
		sign1: false,
		companyAddress1: null,
		filename: '',
		clicked: false,
		esign1: this.props.profile.esign,
		docType: 'template1',
		finalized: false,
		isModalShown: false
	}

	componentWillMount() {
		this.setState({

			companyTitle1: this.props.profile.companyTitle,
			companyName1: this.props.profile.companyName,
			companyAddress1: this.props.profile.companyAddress,
			privateAddress1: this.props.profile.privateAddress,
		})
	}

	handleChange = (e) => {
		if (e.target.id === "sign1" || e.target.id === "withCompany") {
			this.setState({
				[e.target.id]: e.target.checked
			})
		} else {
			this.setState({
				[e.target.id]: e.target.value
			})
		}
	}

	handleSubmit = (e) => {
		e.preventDefault();
		let promise = Promise.resolve();
		promise
			.then(this.props.createProject({
				...this.state,
				sign2: false,
				signedAt: null,
				filename: null,
				finalized: true
			}))
			.then(
				this.props.incrementCount()
			)
			// .then(
			// 	M.toast({ html: `You created and signed a NDA! \nLink sent to ${this.state.email2} (TODO)`, classes: 'rounded', displayLength: 8000 })
			// )
			.then(this.setState({ isModalShown: true }))

	}
	render() {

		const { auth, profile } = this.props
		const fullname = profile.firstName + " " + profile.lastName
		let esignimg = this.state.sign1 ? <img src={profile.esign} style={esignStyle} alt="esign" /> : null
		let esigndate = this.state.sign1 ? moment().format('Do MMMM YYYY') : null
		let address1 = this.state.withCompany ? profile.companyAddress : profile.privateAddress
		const isCompanyRegistered = !!profile.companyName
		const isTitleRegistered = !!profile.companyTitle
		if (!auth.uid) {
			return <Redirect to={'/signin'} />
		} else if (auth.uid && !profile.esign && profile.isLoaded) {
			return <Redirect to={'/mysign'} />
		}

		if ((profile.createCount > 3) && ((profile.plan === null) || (!('plan' in profile)))) {
			return <Redirect to={'/upgrade'} />
		} else if (profile.createCount > 10 && (parseInt(profile.plan, 10) !== 2)) {
			return <Redirect to={'/upgrade'} />
		}

		if (auth.emailVerified) {
			return (
				<div className="grey lighten-5">
					<div className="container">
						<div className="row"></div>
						<form onSubmit={this.handleSubmit} className="white">
							<h5 className="grey-text text-darken-3">Create New NDA</h5>

							<div className="input-field">
								<label className="active" htmlFor="title">Title of the document</label>
								<input type="text" id="title" onChange={this.handleChange} />
							</div>

							<div className="input-field">
								<label className="active" htmlFor="email">Send to</label>
								<input type="email" id="email2" onChange={this.handleChange} />
							</div>

							<div className="input-field">
								<label className="active" htmlFor="name1">Your Name</label>
								<input value={fullname} type="text" id="name1" disabled />
							</div>
							{/* <div className="input-field">
							<label htmlFor="email" className="active">Send from</label>
							<input value={auth.email} type="email" id="email1" disabled />
						</div> */}

							{(isCompanyRegistered && isTitleRegistered) ?
								<div className="input-field">
									<p>
										<label htmlFor="withCompany">
											<input type="checkbox" id="withCompany" onChange={this.handleChange} />
											<span>Include your company and title ({profile.companyTitle}, {profile.companyName})</span>
										</label>
									</p>
								</div>
								:
								<div className="input-field">
									<p>
										<label htmlFor="withCompany">
											<input disabled type="checkbox" id="withCompany" onChange={this.handleChange} />
											<span>Include your company and title (You need to register first at Profile) </span>
										</label>
									</p>
								</div>
							}

							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="divider"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<div className="row"></div>
							<h5 className="grey-text text-darken-3">NDA Preview</h5>


							<div className="row">
								<div className="col s12">
									<div className="card white">
										<div className="card-content black-text">
											{/* I,
          <div className="input-field inline">
											<label htmlFor="name1_template" className="active">Your Name</label>
											<input value={this.state.name1_template} type="text" id="name1_template" onChange={this.handleChange} />
										</div>
										, likes to create a non disclosure agreement with
					<div className="input-field inline">
											<label htmlFor="name2_template" className="active">Your Partner's name</label>
											<input type="text" value={this.state.name2_template} id="name2_template" onChange={this.handleChange} />
										</div>
										.<br />
										The content of non disclosure agreement is
					<div className="input-field inline">
											<label htmlFor="content_template" className="active">Content of NDA</label>
											<input type="text" value={this.state.content_template} id="content_template" onChange={this.handleChange} />

										</div> */}
											<h5>Non Disclosure Agreement ( NDA )</h5>
											<div className="row">
												<h5 className="col s1 m1">1</h5>
												<h5 className="col s10 m10">Disclosure</h5>
											</div>
											<div className="row">
												<div className="col s1 m1">1.1</div>
												<div className="col s10 m10">___(Recipient Name)___ and {fullname} wish to exchange information with each other relating to potentially working together in order to develop and/or {fullname}’s products and/or services (Purpose)</div>
											</div>
											<div className="row">
												<div className="col s1 m1">1.2</div>
												<div className="col s10 m10">In this letter agreement:</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(a)</div>
												<div className="col s10 m10">Confidential Information means all confidential or proprietary information (however recorded or preserved) relating to the Purpose that is disclosed or made available [whether before or after the date of this agreement] (in any form or medium), directly or indirectly, by the Provider to the Recipient.</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(b)</div>
												<div className="col s10 m10">Provider means a party to this letter agreement which discloses or makes available directly or indirectly Confidential Information.</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(c)</div>
												<div className="col s10 m10">Recipient means a party to this letter agreement which receives or obtains directly or indirectly Confidential Information.</div>
											</div>

											<div className="row">
												<div className="col s1 m1">1.3</div>
												<div className="col s10 m10">In consideration of the Provider agreeing to disclose Confidential Information to the Recipient, the Recipient undertakes to the Provider that it shall:</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(a)</div>
												<div className="col s10 m10">keep the Confidential Information secret and confidential;</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(b)</div>
												<div className="col s10 m10">not use or exploit the Confidential Information in any way, except for or in connection with, the Purpose; and</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(c)</div>
												<div className="col s10 m10">only make disclosure of the Confidential Information in accordance with paragraph 1.4 and paragraph 1.5. Any other disclosure can only be made with the Provider's prior written consent.</div>
											</div>

											<div className="row">
												<div className="col s1 m1">1.4</div>
												<div className="col s10 m10">Each party may disclose the Confidential Information to any of its officers, and employees, advisers, subcontractors and contractors that need to know the relevant Confidential Information for the Purpose, provided that it procures that each such person to whom the Confidential Information is disclosed to complies with the obligations set out in this letter agreement as if they were the Recipient.</div>
											</div>



											<div className="row">
												<div className="col s1 m1">1.5</div>
												<div className="col s10 m10">Each party may disclose the Confidential Information to the minimum extent required by:</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(a)</div>
												<div className="col s10 m10">any order of any court of competent jurisdiction or any competent judicial, governmental or regulatory body;</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(b)</div>
												<div className="col s10 m10">the rules of any listing authority or stock exchange on which its shares are listed; or</div>
											</div>
											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s1 m1">(c)</div>
												<div className="col s10 m10">the laws or regulations of any country with jurisdiction over it.</div>
											</div>

											<div className="row">
												<h5 className="col s1 m1">2</h5>
												<h5 className="col s10 m10">Limitations on obligations</h5>
											</div>

											<div className="row">
												<div className="col s1 m1"></div>
												<div className="col s10 m10">The obligations set out in paragraph 1 shall not apply, or shall cease to apply, to Confidential Information which the Recipient can show to the Provider's reasonable satisfaction:</div>
											</div>

											<div className="row">
												<div className="col s1 m1">2.1</div>
												<div className="col s10 m10">that it is, or becomes generally available to the public other than as a direct or indirect result of the information being disclosed by the Recipient in breach of this letter agreement; or</div>
											</div>

											<div className="row">
												<div className="col s1 m1">2.2</div>
												<div className="col s10 m10">was already lawfully known to the Recipient before it was disclosed by the Provider; or</div>
											</div>

											<div className="row">
												<div className="col s1 m1">2.3</div>
												<div className="col s10 m10">has been received by the Recipient from a third party source that is not connected with the Provider and that such source was not under any obligation of confidence in respect of that information.</div>
											</div>



											<div className="row">
												<h5 className="col s1 m1">3</h5>
												<h5 className="col s10 m10">Return of the Confidential Information</h5>
											</div>

											<div className="row">
												<div className="col s1 m1">3.1</div>
												<div className="col s10 m10">If requested by the Provider at any time, the Recipient shall immediately destroy or return to the Provider all documents and other records of the Confidential Information that have been supplied to or generated by the Recipient. If the Confidential Information is stored in electronic form, the Recipient shall permanently erase all such Confidential Information from its computer and communications systems and devices used by it (to the extent technically practicable).</div>
											</div>

											<div className="row">
												<div className="col s1 m1">3.2</div>
												<div className="col s10 m10">The Provider may request the Recipient to certify in writing that it has complied with its obligations in paragraph 3.1.</div>
											</div>


											<div className="row">
												<h5 className="col s1 m1">4</h5>
												<h5 className="col s10 m10">Term and Termination</h5>
											</div>

											<div className="row">
												<div className="col s1 m1">4.1</div>
												<div className="col s10 m10">If either party decides not to continue to be involved in the Purpose with the other party, it shall notify that party immediately.</div>
											</div>

											<div className="row">
												<div className="col s1 m1">4.2</div>
												<div className="col s10 m10">Notwithstanding the termination of discussions between the parties in relation to the Purpose pursuant to paragraph 4.1, the obligations of each party shall continue for a period of two years from the termination of this letter agreement.</div>
											</div>



											<div className="row">
												<h5 className="col s1 m1">5</h5>
												<h5 className="col s10 m10">Acknowledgment</h5>
											</div>

											<div className="row">
												<div className="col s1 m1">5.1</div>
												<div className="col s10 m10">Each party acknowledges and agrees that the Confidential Information may not be accurate or complete and it makes no warranty or representation (whether express or implied) concerning the Confidential Information, or its accuracy or completeness. </div>
											</div>

											<div className="row">
												<div className="col s1 m1">5.2</div>
												<div className="col s10 m10">The Recipient acknowledges that damages alone would not an adequate remedy for any breach of the terms of this letter agreement. Accordingly, the Provider shall be entitled to seek the remedies of injunction, specific performance or other equitable relief for any threatened or actual breach of the terms of this letter agreement.</div>
											</div>


											<div className="row">
												<h5 className="col s1 m1">6</h5>
												<h5 className="col s10 m10">Governing law and Jurisdiction</h5>
											</div>

											<div className="row">
												<div className="col s1 m1">6.1</div>
												<div className="col s10 m10">This Agreement (including non-contractual disputes or claims) shall be governed by, and construed in accordance with, the laws of the Federal Republic of Germany without regard to the conflict of law provisions thereof and excluding the UN Sales Convention. </div>
											</div>

											<div className="row">
												<div className="col s1 m1">6.2</div>
												<div className="col s10 m10">The courts of Berlin, Germany shall have exclusive jurisdiction to settle any dispute or claim that arises out of, or in connection with, this Agreement (including non-contractual disputes or claims), except as otherwise required by applicable law.  Accordingly, any proceedings relating to, or in connection with, this Agreement (including non-contractual disputes or claims) may be brought in such courts.</div>
											</div>

											<div className="row">Please sign and return a copy of this letter agreement if you agree to its terms.</div>
											<div className="row">Yours faithfully,</div>
											{esignimg}
											<div className="row">Signed by {fullname}</div>
											{this.state.withCompany ? <div className="row">Company: {profile.companyTitle}, {profile.companyName}</div> : null}
											<div className="row">Address: {address1}</div>
											<div className="row">Date: {esigndate}</div>

											<div className="row"></div>
											<div className="row">We acknowledge receipt and agree to the terms of this letter agreement:</div>
											<div className="row"></div>
											<div className="row"></div>
											<div className="row"></div>
											<div className="row">Signed by ___(Recipient Name)___</div>
											<div className="row">Address: ___(Recipient Address)___</div>
											<div className="row">Date: ___(Recipient Sign Date)___</div>

										</div>
									</div>
								</div>
							</div>




							<div className="input-field">
								<p>
									<label htmlFor="sign1">
										<input type="checkbox" id="sign1" onChange={this.handleChange} />
										<span>Sign</span>
									</label>
								</p>
							</div>
							{this.state.clicked ? (<div className="preloader-wrapper big active">
								<div className="spinner-layer spinner-teal-only">
									<div className="circle-clipper left">
										<div className="circle"></div>
									</div><div className="gap-patch">
										<div className="circle"></div>
									</div><div className="circle-clipper right">
										<div className="circle"></div>
									</div>
								</div>
							</div>) : (
									<div className="input-field">
										<button className="btn teal lighten-1 z-depth-0" disabled={this.state.title === "" || this.state.email2 === "" || this.state.sign1 === false}>CREATE</button>
									</div>)}
						</form>
						<div className="row"></div>
					</div>

					{this.state.isModalShown &&
						<CreateModal onClose={() => {
							this.setState({
								isModalShown: false
							})
							this.props.history.push('/dashboard')
						}} />
					}

				</div >
			)

		} else if (auth && !auth.emailVerified) {
			return (
				<VerifyEmail auth={auth} />
			)
		}

	}
}

const mapStateToProps = (state) => {
	return {
		auth: state.firebase.auth,
		profile: state.firebase.profile
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		createProject: (project) => dispatch(createProject(project)),
		incrementCount: () => dispatch(incrementCount())
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateTemplate);